import { render, staticRenderFns } from "./PlaceUserFilter.vue?vue&type=template&id=0bc5db5f&"
import script from "./PlaceUserFilter.vue?vue&type=script&lang=js&"
export * from "./PlaceUserFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports